import { useEffect, useState } from 'react';
import { MetaTags } from "react-meta-tags";
import { Card, CardBody, Container } from 'reactstrap';

const InstructionsDeleteAccountGRunner = () => {
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        console.log('🚀 response');
        const response = await fetch('/policy/app_g-runner_delete_account.html');
        const html = await response.text();
        setHtmlContent(html);
      } catch (error) {
        console.error('Error fetching HTML:', error);
      }
    };

    fetchHtml();
  }, []);

  return (
    <div className="account-pages my-5 pt-5">
      <MetaTags>
        <title>G Runner Instructions Delete Account</title>
      </MetaTags>
      <Container>
        <Card>
          <CardBody>
            <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default InstructionsDeleteAccountGRunner;
